import script from "./ActionNeededManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionNeededManagement.vue?vue&type=script&setup=true&lang=js"

import "./ActionNeededManagement.vue?vue&type=style&index=0&id=73285978&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73285978"]])

export default __exports__